import "./css/index.css";
import { ODSLoadingSpinnerProps } from "@/atoms/ODSLoadingSpinner/ODSLoadingSpinner.types";
import classNames from "classnames";
import * as React from "react";
import { memo } from "react";
import ODSBox from "../ODSBox/ODSBox";

const ODSLoadingSpinner = ({
  size = "large",
  labelAlignment = "vertical",
  labelText,
  accessibilityTitle,
  className,
  ...rest
}: ODSLoadingSpinnerProps) => {
  const containerClassName = classNames(
    `ODSLoadingSpinner`,
    `ODSLoadingSpinner--labelAlignment-${labelAlignment}`,
    className
  );

  const spinnerClassName = classNames(
    `ODSLoadingSpinner-Container`,
    `ODSLoadingSpinner-ProgressIndicator--size-${size}`
  );

  return (
    <ODSBox className={containerClassName} {...rest}>
      <svg
        className={spinnerClassName}
        viewBox="0 0 100 100"
        aria-hidden="true"
      >
        <circle
          r="40"
          cx="50"
          cy="50"
          fill="none"
          strokeWidth="6"
          className="ODSLoadingSpinner-Track"
        ></circle>
        <circle
          r="40"
          cx="50"
          cy="50"
          fill="none"
          strokeWidth="6"
          className="ODSLoadingSpinner-ProgressIndicator"
        ></circle>
      </svg>
      <div className="sr-only" aria-live="polite">
        {accessibilityTitle ? accessibilityTitle : labelText || "Loading"}
      </div>
      {labelText ? (
        <div id="title" className="ODSLoadingSpinner-Label" aria-hidden="true">
          {labelText}
        </div>
      ) : null}
    </ODSBox>
  );
};

export default memo(ODSLoadingSpinner);
